
import HeroSection from './components/HeroSection';
import ProgramsSection from './components/ProgramsSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import CoachesSection from './components/CoachesSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div>
      <HeroSection />
      <ProgramsSection />
      <WhyChooseUsSection />
      <CoachesSection />
      <TestimonialsSection />
      <CTASection />
    </div>
  );
}
